import { Box } from '@mui/material';

interface LogoProps {
  size?: 'small' | 'medium' | 'large';
}

export function Logo({ size = 'medium' }: LogoProps) {
  const sizeMap = {
    small: { height: 32 },
    medium: { height: 40 },
    large: { height: 56 },
  };

  return (
    <Box
      component="img"
      src="/Logo_Netyo.png"
      alt="NETYO"
      sx={{
        ...sizeMap[size],
        width: 'auto',
        display: 'block',
      }}
    />
  );
}
